<div class="container-fluid">
  <div class="row">
    <div
      class="col-xl-5 d-none d-xl-block"
      [ngStyle]="{
        'background-image': 'url(assets/images/login/portada_login.png)',
        'background-size': 'cover',
        'background-position': 'center center',
        display: 'block'
      }"
    >
      <img
        class="bg-img-cover bg-center d-none"
        src="assets/images/login/portada_login.png"
        alt="looginpage"
      />
    </div>
    <div class="col-xl-7 p-0">
      <div class="login-card">
        <div>
          <div>
            <a class="logo">
              <img
                class="img-fluid for-light"
                src="assets/images/login/logo.png"
                width="200"
                alt="looginpage"
              />
              <img
                class="img-fluid for-dark"
                src="assets/images/login/logo.png"
                width="200"
                alt="looginpage"
              />
            </a>
          </div>
          <div *ngIf="message">
            <div class="card-header mb-3">
              <h5 class="text-center" style="color: #334c77">{{ paciente }}</h5>
            </div>
            <div
              class="card-body grupos"
              *ngFor="let grupo of grupos; let i = index"
            >
              <p>
                <a
                  style="font-weight: 500"
                  type="button"
                  class="btn btn-primary descarga"
                  (click)="toggleCollapse(i)"
                  [attr.aria-expanded]="collapseIndex === i"
                  aria-controls="collapseExample-{{ i }}"
                >
                  <i
                    style="color: #42caa2; font-size: 15px"
                    class="fa fa-arrow-circle-down mx-2"
                  ></i>
                  {{ grupo.fecha }} - {{ grupo.nombre }} -
                  {{ grupo.descripcion }}
                </a>
              </p>
              <div
                id="collapseExample-{{ i }}"
                [ngbCollapse]="collapseIndex !== i"
              >
                <div class="row g-3">
                  <div class="card-block row">
                    <div class="col-sm-12 col-lg-12 col-xl-12">
                      <div class="table-responsive">
                        <table class="table table-responsive">
                          <thead>
                            <tr>
                              <th></th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody *ngFor="let archivo of grupo.estudios">
                            <tr>
                              <td>
                                <a
                                  class="btn btn-primary"
                                  [href]="getUrlDescarga(archivo.rutayNombre)"
                                  target="_blank"
                                  title="Descargar"
                                >
                                  <i
                                    style="font-size: 20px"
                                    class="fas fa-cloud-download-alt"
                                  ></i>
                                </a>
                              </td>
                              <td
                                class="text-start"
                                style="
                                  color: #42caa2 !important;
                                  font-weight: 500;
                                "
                              >
                                {{ archivo.observacion }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!message" class="text-center" style="color: #334c77">
            <h4>{{ linkExpired }}</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
